import { AuthExtraActionsProps } from './AuthExtraActions.props';
import { AuthExtraActionsRoot } from './AuthExtraActions.styles';

const AuthExtraActions = ({ children }: AuthExtraActionsProps) => {
  if (!children) {
    return null;
  }

  return <AuthExtraActionsRoot data-auth-extra-actions-root="true">{children}</AuthExtraActionsRoot>;
};

export default AuthExtraActions;
